import { AsyncModule } from "vuex-async-mutations";
import { Profile, Installer, ProfileUser } from "@/types";
import { v4 as uuid } from "uuid";

interface ProfileState {
  user: Profile;
  installers: Installer[];
  uuid: string;
}

const stateFactory = (): ProfileState => ({
  user: {
    email: null,
    id: null,
    name: "",
    canEditInMaintenance: false
  },
  installers: [],
  uuid: uuid()
});

export const module: AsyncModule<ProfileState, any> = {
  namespaced: true,

  async: true,

  state: stateFactory,

  getters: {
    ["installers"](state) {
      return state.installers;
    },
    ["userEmail"](state) {
      return state.user.email;
    },
    ["userId"](state) {
      return state.user.id;
    },
    ["canEditInMaintenance"](state) {
      return state.user.canEditInMaintenance === true;
    }
  },

  /* eslint-disable no-param-reassign */

  mutations: {
    ["reset"](state) {
      Object.assign(state, stateFactory());
    }
  },
  /* eslint-disable no-param-reassign */

  actionsAsync: {
    ["fetch:profile"]: {
      async handler({ commitAsync }) {
        const profile: ProfileUser = await commitAsync(this.$axios.$get("/users/profile"));

        this.dispatch("on:profile", profile);

        return profile;
      },

      resolved(state, { user, installers }: { user: Profile; installers: Installer[] }) {
        state.user = user;
        state.installers = installers;
      }
    }
  },

  actions: {
    // "events"

    ["reset"]: {
      root: true,
      handler: ({ commit }) => commit("reset")
    },

    ["authenticated"]: {
      root: true,
      handler: ({ dispatch }) => dispatch("fetch:profile")
    }
  }
};

export default module;
